export const lineProps = [
    {
        name: ['planfamiliarprincipal', 'plan familiar principal'],
        title: 'izzi móvil familiar', // Important: This value should match with the one in the offer, the value of the title in izzimovil array
        wheigth: 3,
        shouldShowPersonalizedName: true,
        expandedDescription: 'Incluye 3 líneas...',
        required: 'izzi móvil adicional',
    },
    {
        name: ['plan familiar adicional'],
        title: 'izzi móvil adicional', // Important: This value should match with the one in the offer, the value of the title in izzimovil array
        wheigth: 0,
        shouldShowPersonalizedName: true,
        shouldShowInCart: false,
        shouldCountInTotal: false,
    },
];
